module.exports = __webpack_public_path__ + "img/2.3632c70b.jpg";